<template>
  <main id="main">


    <!-- ======= Facts Section ======= -->
    <!--
    <section id="facts" class="facts">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>Facts</h2>
          <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p>
        </div>

        <div class="row">

          <div class="col-lg-3 col-md-6">
            <div class="count-box">
              <i class="icofont-simple-smile"></i>
              <span data-toggle="counter-up">232</span>
              <p>Happy Clients</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-md-0">
            <div class="count-box">
              <i class="icofont-document-folder"></i>
              <span data-toggle="counter-up">521</span>
              <p>Projects</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-lg-0">
            <div class="count-box">
              <i class="icofont-live-support"></i>
              <span data-toggle="counter-up">1,463</span>
              <p>Hours Of Support</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-lg-0">
            <div class="count-box">
              <i class="icofont-users-alt-5"></i>
              <span data-toggle="counter-up">15</span>
              <p>Hard Workers</p>
            </div>
          </div>

        </div>

      </div>
    </section>
    -->
    <!-- End Facts Section -->

    <!-- ======= Skills Section ======= -->
    <!--
    <section id="skills" class="skills section-bg">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>Skills</h2>
          <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p>
        </div>

        <div class="row skills-content">

          <div class="col-lg-6">

            <div class="progress">
              <span class="skill">HTML <i class="val">100%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">CSS <i class="val">90%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">JavaScript <i class="val">75%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

          </div>

          <div class="col-lg-6">

            <div class="progress">
              <span class="skill">PHP <i class="val">80%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">WordPress/CMS <i class="val">90%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">Photoshop <i class="val">55%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

          </div>

        </div>

      </div>
    </section>
    -->
    <!-- End Skills Section -->
    <!-- ======= Resume Section ======= -->
    <section id="resume" class="resume">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>Experiencia Profesional</h2>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <h3 class="resume-title">TRASCENDER</h3>
            <div class="resume-item pb-0">
              <h5>2017-2018</h5>
              <h4>Full Stack</h4>
              <p style="text-align: justify;">
                En esta empresa desarrollé sistemas para la gestion de inventario de diferentes microempresas abarroteras, contó con módulos básicos como, altas y bajas de productos, así como su venta en menudeo y mayoreo al público.
              </p>
              <p>Herramientas</p>
              <ul class="mt-n1">
                <li>Lenguaje C#</li>
                <li>Window Form</li>
                <li>SQL Server 2014</li>
              </ul>
            </div>

            <!--
                        <h3 class="resume-title">“Paperless"</h3>
            <div class="resume-item">
              <h4>Grupo salinas CDMX</h4>
              <h5>Agosto 2019</h5>
              <p><em>El diseño de la aplicación fue de Banco Azteca</em></p>
              <p>Servicio REST para generar tickets y enviarlos por distintas plataformas,
                Integración de Apis WhatsApp, email, SMS.</p>
              <ul>
                <li>Lenguaje PHP</li>
                <li>JavaScript</li>
                <li>Libreria Angular js</li>
              </ul>
            </div>
            <div class="resume-item">
              <h4>Prianti Consultores</h4>
              <h5>Enero 2020 - Febrero 2021</h5>
              <p><em>Desarrollo de software de máxima calidad, inteligencia de negocios de última generación.</em></p>
              <p>Estuve a cargo de múltiples maquetas y desarrollos completos, trabajando en la parte del Front y Backend.
                Proyectos como BI, Sistemas de inventario, Algoritmos para la lectura de archivos, PDF, XLS, entre otros.
              </p>
            </div>
            -->
          </div>
          <!--
                    <div class="col-lg-6">
            <h3 class="resume-title">PRIANTI CONSULTING</h3>
            <div class="resume-item">
              <h4>Farmazonmx</h4>
              <p><em>Mantenimiento de tienda online, arreglo bugs, se añadieron funciones, como la carga de productos por archivos Excel entre otras características. </em></p>
              <ul>
                <li>PHP</li>
                <li>JQUERY</li>
                <li>JavaScript</li>
                <li>HTML</li>
                <li>CSS</li>
              </ul>
            </div>
            <div class="resume-item">
              <h3 class="resume-title">OCR Animal Karma</h3>
              <h4>Animal Karma</h4>
              <h5>Noviembre 2020</h5>
              <p><em>Desarrollo de sistema para el reconocimiento de imágenes, revisión de documentos
                electrónicos, integración de servicios como OCR, RDE, extracción de metadatos. </em></p>
              <ul>
                <li>Python</li>
                <li>Vue Js</li>
                <li>MYSQL</li>
                <li>Google vision AI</li>
              </ul>
            </div>
          </div>
          -->
          <div class="col-lg-6">
            <h3 class="resume-title">PRIANTI CONSULTING</h3>
            <div class="resume-item pb-0">
              <h5>2020-2021</h5>
              <h4>Full Stack</h4>
              <p style="text-align: justify;">Estuve a cargo de múltiples proyectos dentro de la consultora,
                participando muy de cerca con sistemas de Business Intelligence,
                aplicaciones de venta y reparto como rappi o Didi, así también en un
                sistema para expedir seguros de diferentes ramos
              </p>
              <p>Herramientas</p>
              <ul class="mt-n1">
                <li>Lenguaje PHP</li>
                <li>Framework VueJS</li>
                <li>Framework Laravel</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <h3 class="resume-title">FREELANCE</h3>
            <div class="resume-item pb-0">
              <h5>2019 - Actualmente</h5>
              <h4>FULL STACK</h4>
              <p style="text-align: justify;">
                Desarrollo sistemas a la medida, he colaborado con equipos multidiciplinario, programando para grandes empresa de diferentes sectores.
              </p>
              <p>Herramientas</p>
              <ul class="mt-n1">
                <li>Lenguaje PHP</li>
                <li>Lenguaje JavaScript</li>
                <li>Framework VueJS</li>
                <li>Framework Laravel</li>
              </ul>
            </div>

          </div>
        </div>

      </div>
    </section><!-- End Resume Section -->

    <!-- ======= Portfolio Section ======= -->
    <!-- End Portfolio Section -->

    <portafolio-component/>
    <!--
    <section id="services" class="services">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>¿Como puedo ayudarte?</h2>
          <p>
            Para comenzar, es verdaderamente necesario adoptar nuevas tecnologías, para estar a la altura de la competencia, sí estás preparado para comenzar el proceso, contáctame que puedo ayudarte en lo siguiente.
          </p>
        </div>

        <div class="row">

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
            <div class="icon-box iconbox-blue">
              <div class="icon">
                <svg width="100" height="100" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
                  <path stroke="none" stroke-width="0" fill="#f5f5f5" d="M300,521.0016835830174C376.1290562159157,517.8887921683347,466.0731472004068,529.7835943286574,510.70327084640275,468.03025145048787C554.3714126377745,407.6079735673963,508.03601936045806,328.9844924480964,491.2728898941984,256.3432110539036C474.5976632858925,184.082847569629,479.9380746630129,96.60480741107993,416.23090153303,58.64404602377083C348.86323505073057,18.502131276798302,261.93793281208167,40.57373210992963,193.5410806939664,78.93577620505333C130.42746243093433,114.334589627462,98.30271207620316,179.96522072025542,76.75703585869454,249.04625023123273C51.97151888228291,328.5150500222984,13.704378332031375,421.85034740162234,66.52175969318436,486.19268352777647C119.04800174914682,550.1803526380478,217.28368757567262,524.383925680826,300,521.0016835830174"></path>
                </svg>
                <i class="bx bx-phone"></i>
              </div>
              <h4><a href="">Web App</a></h4>
              <p>
                Muéstrale a tus clientes, el contenido de tu empresa directamente en la palma de sus manos. Tu página adaptada a dispositivos móviles.
              </p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="zoom-in" data-aos-delay="200">
            <div class="icon-box iconbox-orange ">
              <div class="icon">
                <svg width="100" height="100" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
                  <path stroke="none" stroke-width="0" fill="#f5f5f5" d="M300,582.0697525312426C382.5290701553225,586.8405444964366,449.9789794690241,525.3245884688669,502.5850820975895,461.55621195738473C556.606425686781,396.0723002908107,615.8543463187945,314.28637112970534,586.6730223649479,234.56875336149918C558.9533121215079,158.8439757836574,454.9685369536778,164.00468322053177,381.49747125262974,130.76875717737553C312.15926192815925,99.40240125094834,248.97055460311594,18.661163978235184,179.8680185752513,50.54337015887873C110.5421016452524,82.52863877960104,119.82277516462835,180.83849132639028,109.12597500060166,256.43424936330496C100.08760227029461,320.3096726198365,92.17705696193138,384.0621239912766,124.79988738764834,439.7174275375508C164.83382741302287,508.01625554203684,220.96474134820875,577.5009287672846,300,582.0697525312426"></path>
                </svg>
                <i class="bx bx-laptop"></i>
              </div>
              <h4><a href="">Programas para PC</a></h4>
              <p>¿Necesitas sistemas para tu negocio internamente? <br> También puedo ayudarte, desarrollando tu sistema a la medida.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0" data-aos="zoom-in" data-aos-delay="300">
            <div class="icon-box iconbox-pink">
              <div class="icon">
                <svg width="100" height="100" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
                  <path stroke="none" stroke-width="0" fill="#f5f5f5" d="M300,541.5067337569781C382.14930387511276,545.0595476570109,479.8736841581634,548.3450877840088,526.4010558755058,480.5488172755941C571.5218469581645,414.80211281144784,517.5187510058486,332.0715597781072,496.52539010469104,255.14436215662573C477.37192572678356,184.95920475031193,473.57363656557914,105.61284051026155,413.0603344069578,65.22779650032875C343.27470386102294,18.654635553484475,251.2091493199835,5.337323636656869,175.0934190732945,40.62881213300186C97.87086631185822,76.43348514350839,51.98124368387456,156.15599469081315,36.44837278890362,239.84606092416172C21.716077023791087,319.22268207091537,43.775223500013084,401.1760424656574,96.891909868211,461.97329694683043C147.22146801428983,519.5804099606455,223.5754009179313,538.201503339737,300,541.5067337569781"></path>
                </svg>
                <i class="bx bxl-internet-explorer"></i>
              </div>
              <h4><a href="">Pagina web</a></h4>
              <p>Posiciona tu negocio en internet, para que el mundo sepa que existes y que eres su mejor opción.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="100">
            <div class="icon-box iconbox-yellow">
              <div class="icon">
                <svg width="100" height="100" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
                  <path stroke="none" stroke-width="0" fill="#f5f5f5" d="M300,503.46388370962813C374.79870501325706,506.71871716319447,464.8034551963731,527.1746412648533,510.4981551193396,467.86667711651364C555.9287308511215,408.9015244558933,512.6030010748507,327.5744911775523,490.211057578863,256.5855673507754C471.097692560561,195.9906835881958,447.69079081568157,138.11976852964426,395.19560036434837,102.3242989838813C329.3053358748298,57.3949838291264,248.02791733380457,8.279543830951368,175.87071277845988,42.242879143198664C103.41431057327972,76.34704239035025,93.79494320519305,170.9812938413882,81.28167332365135,250.07896920659033C70.17666984294237,320.27484674793965,64.84698225790005,396.69656628748305,111.28512138212992,450.4950937839243C156.20124167950087,502.5303643271138,231.32542653798444,500.4755392045468,300,503.46388370962813"></path>
                </svg>
                <i class="bx bx-mobile"></i>
              </div>
              <h4><a href="">Aplicación Movil</a></h4>
              <p>
                Si lo que quieres es demostrar confianza, adelanté, necesitas una aplicación propia.
              </p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="200">
            <div class="icon-box iconbox-red">
              <div class="icon">
                <svg width="100" height="100" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
                  <path stroke="none" stroke-width="0" fill="#f5f5f5" d="M300,532.3542879108572C369.38199826031484,532.3153073249985,429.10787420159085,491.63046689027357,474.5244479745417,439.17860296908856C522.8885846962883,383.3225815378663,569.1668002868075,314.3205725914397,550.7432151929288,242.7694973846089C532.6665558377875,172.5657663291529,456.2379748765914,142.6223662098291,390.3689995646985,112.34683881706744C326.66090330228417,83.06452184765237,258.84405631176094,53.51806209861945,193.32584062364296,78.48882559362697C121.61183558270385,105.82097193414197,62.805066853699245,167.19869350419734,48.57481801355237,242.6138429142374C34.843463184063346,315.3850353017275,76.69343916112496,383.4422959591041,125.22947124332185,439.3748458443577C170.7312796277747,491.8107796887764,230.57421082200815,532.3932930995766,300,532.3542879108572"></path>
                </svg>
                <i class="bx bx-paint"></i>
              </div>
              <h4><a href="">Diseño</a></h4>
              <p>Tu sistema en una maqueta, tu página web, tu aplicación móvil, para darte un previo de como quedaría.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay="300">
            <div class="icon-box iconbox-teal">
              <div class="icon">
                <svg width="100" height="100" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
                  <path stroke="none" stroke-width="0" fill="#f5f5f5" d="M300,566.797414625762C385.7384707136149,576.1784315230908,478.7894351017131,552.8928747891023,531.9192734346935,484.94944893311C584.6109503024035,417.5663521118492,582.489472248146,322.67544863468447,553.9536738515405,242.03673114598146C529.1557734026468,171.96086150256528,465.24506316201064,127.66468636344209,395.9583748389544,100.7403814666027C334.2173773831606,76.7482773500951,269.4350130405921,84.62216499799875,207.1952322260088,107.2889140133804C132.92018162631612,134.33871894543012,41.79353780512637,160.00259165414826,22.644507872594943,236.69541883565114C3.319112789854554,314.0945973066697,72.72355303640163,379.243833228382,124.04198916343866,440.3218312028393C172.9286146004772,498.5055451809895,224.45579914871206,558.5317968840102,300,566.797414625762"></path>
                </svg>
                <i class="bx bxl-adobe"></i>
              </div>
              <h4><a href="">Logotipo y branding</a></h4>
              <p>¿Estás comenzando un negocio? <br> Deberías tener tu propio estilo, tu propia imagen, que tus clientes logren identificarte fácilmente</p>
            </div>
          </div>

        </div>

      </div>
    </section>
    -->

    <!-- ======= Testimonials Section ======= -->
    <!--
    <section id="testimonials" class="testimonials section-bg">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>Testimonials</h2>
        </div>

        <div class="owl-carousel testimonials-carousel" data-aos="zoom-in" data-aos-delay="100">

          <div class="testimonial-item">
            <img src="assets/img/testimonials/testimonials-1.jpg" class="testimonial-img" alt="">
            <h3>Saul Goodman</h3>
            <h4>Ceo &amp; Founder</h4>
            <p>
              <i class="bx bxs-quote-alt-left quote-icon-left"></i>
              Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
              <i class="bx bxs-quote-alt-right quote-icon-right"></i>
            </p>
          </div>

          <div class="testimonial-item">
            <img src="assets/img/testimonials/testimonials-2.jpg" class="testimonial-img" alt="">
            <h3>Sara Wilsson</h3>
            <h4>Designer</h4>
            <p>
              <i class="bx bxs-quote-alt-left quote-icon-left"></i>
              Export tempor illum tamen malis malis eram quae irure esse labore quem cillum quid cillum eram malis quorum velit fore eram velit sunt aliqua noster fugiat irure amet legam anim culpa.
              <i class="bx bxs-quote-alt-right quote-icon-right"></i>
            </p>
          </div>

          <div class="testimonial-item">
            <img src="assets/img/testimonials/testimonials-3.jpg" class="testimonial-img" alt="">
            <h3>Jena Karlis</h3>
            <h4>Store Owner</h4>
            <p>
              <i class="bx bxs-quote-alt-left quote-icon-left"></i>
              Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram fore quis sint minim.
              <i class="bx bxs-quote-alt-right quote-icon-right"></i>
            </p>
          </div>

          <div class="testimonial-item">
            <img src="assets/img/testimonials/testimonials-4.jpg" class="testimonial-img" alt="">
            <h3>Matt Brandon</h3>
            <h4>Freelancer</h4>
            <p>
              <i class="bx bxs-quote-alt-left quote-icon-left"></i>
              Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam.
              <i class="bx bxs-quote-alt-right quote-icon-right"></i>
            </p>
          </div>

          <div class="testimonial-item">
            <img src="assets/img/testimonials/testimonials-5.jpg" class="testimonial-img" alt="">
            <h3>John Larson</h3>
            <h4>Entrepreneur</h4>
            <p>
              <i class="bx bxs-quote-alt-left quote-icon-left"></i>
              Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid.
              <i class="bx bxs-quote-alt-right quote-icon-right"></i>
            </p>
          </div>

        </div>

      </div>
    </section>
    -->
    <!-- End Testimonials Section -->
    <!--
    Nombre,
    email
    asunto
    mensaje
    -->
    <!-- ======= Contact Section ======= -->
    <section id="contact" class="contact">
      <div class="container" data-aos="fade-up">

        <div class="section-title">
          <h2>Contacto</h2>
        </div>

        <div class="row mt-1">

          <div class="col-lg-4">
            <div class="info">
              <div class="address">
                <i class="icofont-google-map"></i>
                <h4>Dirección:</h4>
                <p>San Nicolas de los Garza N.L MX</p>
              </div>

              <div class="email">
                <i class="icofont-envelope"></i>
                <h4>Correo:</h4>
                <p>antoniohernandezjosesantiago@gmail.com</p>
              </div>

              <!-- =======
                           <div class="phone">
                <i class="icofont-phone"></i>
                <h4>Teléfono:</h4>
                <p>+52 7713 4897 113</p>
              </div>
              -->

            </div>

          </div>

          <div class="col-lg-8 mt-5 mt-lg-0">

            <form role="form" class="php-email-form contact-form" @submit.prevent="sendEmail">
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <input type="text" name="user_name" class="form-control" v-model="emails.name" id="user_name" placeholder="¿Como te llamas?" data-rule="minlen:4" data-msg="Por favor, escribe almenos 4 caracteres" />
                  <div class="validate"></div>
                </div>
                <div class="col-md-6 form-group">
                  <input type="email" class="form-control" name="user_email" id="user_email" v-model="emails.email" placeholder="¿cual es tu email?" data-rule="email" data-msg="Por favor, escribe un email valido." />
                  <div class="validate"></div>
                </div>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" name="subject" id="subject" placeholder="Asunto del mensaje" v-model="emails.subject" data-rule="minlen:4" data-msg="Por favor, escribe almenos 8 caracteres" />
                <div class="validate"></div>
              </div>
              <div class="form-group">
                <textarea class="form-control" name="message" rows="5" data-rule="required" v-model="emails.message" data-msg="Please write something for us" placeholder="¿Cual es tu mensaje?"></textarea>
                <div class="validate" ></div>
              </div>
              <div class="mb-3">
                <div class="loading">Loading</div>
                <div class="error-message"></div>
                <div class="sent-message">Your message has been sent. Thank you!</div>
              </div>
              <div class="text-center"><button type="submit">Enviar el mensaje</button></div>
            </form>

          </div>

        </div>

      </div>
    </section><!-- End Contact Section -->

    <div class="layout">
      <SocialChat class="whatsapp-chat" icon :attendants="attendants">
        <p slot="header">Responderé en menos de 5 min. <br>
        (Guiño, Guiño)
        </p>
        <template v-slot:button>
          <img
              src="https://raw.githubusercontent.com/ktquez/vue-social-chat/master/src/icons/whatsapp.svg"
              alt="icon whatsapp"
              aria-hidden="true"
          >
        </template>
        <small slot="footer">Horario : 9am a 6pm</small>

      </SocialChat>
    </div>
  </main>

</template>

<script>
import emailjs from 'emailjs-com';
import PortafolioComponent from "@/components/PortafolioComponent";


export default {
name: "MainComponent",
  components:{
    PortafolioComponent
  },
  data:()=>({
    attendants: [
      {
        app: 'whatsapp',
        label: 'Fullstack',
        name: 'José Santiago',
        number: '+527713497113',
        avatar: {
          src: 'https://pbs.twimg.com/profile_images/1349977618343460865/Xu62Rz3U_400x400.jpg',
          alt: 'José Santiago'
        }
      },
      // ...
    ],
    emails:{
      name:null,
      email:null,
      subject:null,
      message:null
    },
    active:false
  }),
  methods:{
    oninput(){

    },
    sendEmail(e){
      if (this.emails.name ==null || this.emails.email ==null || this.emails.subject ==null || this.emails.message ==null){
        this.$fire({
          title: "¡Ups!",
          text: "Necesitas rellenar todo el formulario",
          type: "warning",
          timer: 3000
        }).then(r => {
          console.log(r.value);
        });
      }else {

        emailjs.sendForm('service_jryh2js','template_deiglp9',e.target,'user_8B00XPfvnqrXGs1La3yQu').then(res=>{
          console.log(res.status)
          if (res.status == 200){
            e.target.reset()
            this.$fire({
              title: "Excelente",
              text: "En breve me comunicare contigo.",
              type: "success",
              timer: 3000
            }).then(r => {
              console.log(r.value);
            });



          }
        },(error)=>{
          console.log(error)
        })

      }



    }
  }
}
</script>

<style>
.whatsapp-chat {
  --whatsapp: #46c056;
  --vsc-bg-header: var(--whatsapp);
  --vsc-bg-button: var(--whatsapp);
  --vsc-outline-color: var(--whatsapp);
}
</style>